import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type RapidElectronicsAccountCodeDTO = z.infer<typeof RapidElectronicsAccountCodeDTORuntype>;
export const RapidElectronicsAccountCodeDTORuntype = z.string();

export type RapidElectronicsTokenDTO = z.infer<typeof RapidElectronicsTokenDTORuntype>;
export const RapidElectronicsTokenDTORuntype = z.string();

export interface RapidElectronicsCredentialsDTO extends z.infer<typeof RapidElectronicsCredentialsDTORuntype> {}
export const RapidElectronicsCredentialsDTORuntype = z.object({
    account_code: RapidElectronicsAccountCodeDTORuntype,
    token: RapidElectronicsTokenDTORuntype,
});

export interface RapidElectronicsResponseBodyDTO extends z.infer<typeof RapidElectronicsResponseBodyDTORuntype> {}
export const RapidElectronicsResponseBodyDTORuntype = z.object({
    data: RapidElectronicsCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
